export function addDownload (context, download) {
  let downloads = context.state.downloads
  downloads.push(download)
  context.commit('setDownloads', downloads)
}
